export const errorMessages = {
  requiredBusinessName: 'Enter Business Name',
  requiredBusinessNameNotMoreThan100Characters:
    'Business Name Should not be more than 100 characters',
  requiredBusinessNameMoreThan2Characters:
    'Business Name Should be more than 2 characters',
  requiredBusinessWebsiteUrl: 'Business Website is Mandatory',
  requiredBusinessWebsiteNotMoreThan320Characters:
    'Business Website Should not be more than 320 Characters',
  requiredBusinessWebsiteMoreThan4Characters:
    'Business Website Should be more than 4 Characters',
  requiredValidBusinessWebsite: 'Please enter a valid Business Website',

  requiredFirstName: 'Enter First Name',
  requiredFirstNameNotMoreThan100Characters:
    'First name Should not be more than 100 Characters',
  requiredFirstNameMoreThan1Characters:
    'First name Should be more than 1 Characters',

  firstNameNotAllowedSpecialCharacters:
    'No special characters , Empty spaces or Numbers are Allowed',

  requiredLastName: 'Enter Last Name',
  requiredLastNameNotMoreThan100Characters:
    'Last name Should not be more than 100 Characters',
  lastNameNotAllowedSpecialCharacters:
    'No special characters , Empty spaces or Numbers are Allowed',

  requiredEmail: 'Enter Email Address',
  invalidEmail: 'Enter a valid Email Address',
  requiredPassword: 'Enter password',
  requiredConfirmPassword: 'Confirm password',
  invalidPassword: 'Min 8 chars, with uppercase, lowercase, number & symbol',
  invalidConfirmPassword:
    'Min 8 chars, with uppercase, lowercase, number & symbol'
};
